import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./coursesTour.css";

export function startCourseImportTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour hướng dẫn nhập khóa học từ Excel/CSV và xử lý lỗi import.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="course-import-header"]',
      title: "Header import",
      description:
        "Nút lấp lánh để mở lại tour nhanh trong modal import.",
      side: "bottom",
    },
    {
      selector: '[data-tour="course-import-upload"]',
      title: "Vùng chọn file",
      description:
        "Chọn file .xlsx/.xls/.csv hợp lệ để bắt đầu.",
      side: "bottom",
    },
    {
      selector: '[data-tour="course-import-template"]',
      title: "Tải file mẫu",
      description:
        "Nên dùng file mẫu CSV để tránh sai cấu trúc cột.",
      side: "bottom",
    },
    {
      selector: '[data-tour="course-import-note"]',
      title: "Lưu ý dữ liệu",
      description:
        "Xem các quy tắc mapping môn học, trình độ và cột Y/N.",
      side: "top",
    },
    {
      selector: '[data-tour="course-import-errors"]',
      title: "Báo lỗi import",
      description:
        "Nếu có lỗi theo dòng, khối này hiển thị chi tiết để sửa file.",
      side: "top",
    },
    {
      selector: '[data-tour="course-import-actions"]',
      title: "Hành động cuối",
      description:
        "Bấm Nhập dữ liệu để xử lý file, hoặc Hủy để đóng modal.",
      side: "top",
    },
  ];

  const alignElementInView = (el) => {
    if (!el || typeof el.scrollIntoView !== "function") return;
    el.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  };

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy mở modal rồi thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "courses-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    onHighlightStarted: (element) => {
      alignElementInView(element);
    },
    steps,
  });

  d.drive();
}
